import React, { useEffect, useState } from 'react';
import FormComponent from './form';
import PropTypes from "prop-types"
import { withTranslation } from 'react-i18next';
import withRouter from "components/Common/withRouter"
import { Container } from 'reactstrap';
import { MetaTags } from 'react-meta-tags';
import { Spin } from 'antd';
import { GET_ContactTypeVendor } from 'helpers/url_helper';
import { get } from 'helpers/api_helper';

const VendorPaymentCreate = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [vendorOptions, setVendorOptions] = useState('')

  const getVendorList = async () => {
    setIsLoading(true)
    await get(GET_ContactTypeVendor + "&page=1&paginate=10000")
      .then(res => {
        if (res?.status == 200 && res?.data?.data.length > 0) {
          let NewOptions = []
          res?.data?.data?.map(item =>
            NewOptions.push({
              label: item?.company_name,
              value: item?.contact_id,
            })
          )
          setVendorOptions(NewOptions)
        } else {
          setVendorOptions([])
        }
        setIsLoading(false)
      })
      .catch(error => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    getVendorList()
  }, [])


  return (
    <div>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <div className="page-content">
          <MetaTags>
            <title>Add Shipment | Katlax OMS</title>
          </MetaTags>
          <Container fluid>
            <div className='mt-4'>
              <FormComponent
                setIsLoading={setIsLoading}
                vendorOptions={vendorOptions}
              />
            </div>
          </Container>
        </div>
      </Spin>
    </div>
  );
};

VendorPaymentCreate.propTypes = {
  t: PropTypes.any,
}
export default withRouter(withTranslation()(VendorPaymentCreate))
